(() => {
  'use strict';

  const root = document.querySelector('.dh-home--top');
  if (!root) return;

  const publish = (name, detail = {}) => {
    const payload = { event: `daluca_home_${name}`, ...detail };

    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
    } catch (_) {}

    try {
      document.dispatchEvent(new CustomEvent('daluca:home', { detail: payload }));
    } catch (_) {}
  };

  document.addEventListener('click', (event) => {
    const target = event.target.closest('[data-daluca-home-event]');
    if (!target) return;
    publish(target.dataset.dalucaHomeEvent || 'click', {
      label: target.dataset.dalucaHomeLabel || '',
      href: target.href || '',
      path: window.location.pathname
    });
  }, { passive: true });

  document.querySelectorAll('[data-daluca-film]').forEach((film) => {
    const play = film.querySelector('[data-daluca-film-play]');
    const video = film.querySelector('.dh-film__video');
    if (!play || !video) return;

    play.addEventListener('click', () => {
      film.classList.add('is-playing');
      video.hidden = false;
      const attempt = video.play();
      if (attempt && typeof attempt.catch === 'function') attempt.catch(() => {});
    }, { once: true });
  });

  const milestones = [25, 50, 75, 90];
  const sent = new Set();
  let scheduled = false;

  const reportDepth = () => {
    scheduled = false;
    const doc = document.documentElement;
    const max = Math.max(1, doc.scrollHeight - window.innerHeight);
    const percent = Math.min(100, Math.round((window.scrollY / max) * 100));
    milestones.forEach((point) => {
      if (percent >= point && !sent.has(point)) {
        sent.add(point);
        publish('scroll_depth', { percent: point, path: window.location.pathname });
      }
    });
  };

  window.addEventListener('scroll', () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(reportDepth);
  }, { passive: true });
})();
